import apiClient from './apiClient'


const getTenants = () => {
  return apiClient.get('/Tenant')
}


export default {
  getTenants
}
